import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/layout'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    meta: { title: '登录', index: 0 },
    component: (resolve) => require(['@/views/login'], resolve)
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        meta: { title: '我的预约', index: 0 },
        component: (resolve) => require(['@/views/index'], resolve)
      },
      {
        path: 'talk',
        name: 'talk',
        meta: { title: '我的咨询', index: 1 },
        component: (resolve) => require(['@/views/talk'], resolve)
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
